import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@blend-ed/blendx-ui';
import { format } from 'date-fns';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';
import profileImageDefault from '../../../assets/images/profile-image-default.png';

function ChatTrayItem({ user, message, time, userImage }) {
    if (user !== 'learner') {
        return (
            <div className="chat-item">
                <Avatar src={userImage || profileImageDefault} type="image" />
                <div className="chat-item-chat-message-container">
                    <div
                        className="chat-item-chat-message"
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                    <div className="chat-item-chat-message-time">{time}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="chat-item chat-item-user">
            <div className="chat-item-user-message-container">
                <div className="chat-item-chat-message">{message}</div>
                <div className="chat-item-user-message-time">{time}</div>
            </div>
            <Avatar src={userImage || profileImageDefault} type="image" />
        </div>
    );
}

const MessageBubble = ({ message }) => {
    const intl = useIntl();

    const formatTime = (dateString) => {
        return format(new Date(dateString), 'h:mm a');
    };

    return (
        <ChatTrayItem
            message={message.content}
            time={formatTime(message.timestamp)}
            userImage={message?.userImage}
            user={message.sender}
        />
    );
};

MessageBubble.propTypes = {
    message: PropTypes.shape({
        id: PropTypes.number.isRequired,
        sender: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
        timestamp: PropTypes.string.isRequired,
        userImage: PropTypes.string.isRequired
    }).isRequired
};

export default MessageBubble; 